import { renderBlock } from '../../../common/helpers/didYouKnowHelper';
import i10n from '../../../common/i10n';

export const renderFirstColumnWithAddedLink = (text) =>
        <div>{i10n._VIEW_CONVERTTOPDFA_DIDYOUKNOW_COLUMN_1_DESC_ALL} {renderBlock(text[0][8].toLowerCase(), { type: 'link', href: "https://www.gdpicture.com/pdf-sdk/pdfa-conversion/" })}</div>